export default __webpack_public_path__ + "static/media/17_roscoe_powers.30a2055c.jpg";